import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["formData", "onChange", "onError", "children"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import predicate from "predicate";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import Form from "react-jsonschema-form";
import { fieldProps } from "react-jsonschema-form/lib/types";
import DescriptionField from "react-jsonschema-form/lib/components/fields/DescriptionField";
import TitleField from "react-jsonschema-form/lib/components/fields/TitleField";
import dateDiffDays from "mibaby-common/util/date-diff-days";
import mbFetch from "mibaby-common/util/fetch";
import hook from "mibaby-common/util/hook";
import * as fields from "./fields";
import * as templates from "./templates";
import * as widgets from "./widgets";
import { createTransformer as createErrorTransformer } from "./transformErrors";
import loadable from "../loadable";
import { useValidation } from "./validate";
import { withBBCodeMapper } from "../util/hoc/withBBCode";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export * from "./translateSchema";
export * from "./validate";

/**
 * `MbForm`/`DefaultForm`: the shared form widget wrapping `react-jsonschema-form` with
 * mibaby's custom fields/widgets/templates (`./fields`, `./widgets`, `./templates`,
 * merged over rjsf's defaults, with BBCode support on title/description/checkbox
 * labels), schema-aware validation (`./validate`) and error transforms (`./transformErrors`).
 * `MbForm` also owns AJAX submission when given a `submitUrl`: it POSTs `formData`,
 * expects `{ success | redirect }` or `{ error | validationErrors }` back, and drives
 * the form's `status` (`invalid`/`submitting`/`valid`/`submitted`) from the result.
 * `DefaultForm` adds local `formData`/`errors` state on top so the caller doesn't have
 * to, plus a top-level async-error banner. Re-exports `./translateSchema` and
 * `./validate`.
 *
 * Part of the mibaby-frontend shared component/style library component — see
 * docs/wiki/System/shared/mibaby-frontend-package.md.
 */

/*
 * Helpers
 */

predicate.agify = predicate.curry(function (val, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    otherPredicate = _ref2[0],
    days = _ref2[1];
  return predicate[otherPredicate](dateDiffDays(new Date(val), new Date()), days);
});
var HtmlToReact = loadable(function () {
  return import(/* webpackChunkName: "rich-content" */"../HTML");
});
var withBBCode = withBBCodeMapper();

/**
 * Overrides
 * @type {import("react-jsonschema-form").FormProps}
 */
var overrides = _objectSpread(_objectSpread({
  noHtml5Validate: true,
  showErrorList: false
}, templates), {}, {
  // Custom Fields

  fields: _objectSpread(_objectSpread({}, fields), {}, {
    TitleField: withBBCode(TitleField),
    DescriptionField: withBBCode(DescriptionField)
  }),
  // Custom Widgets

  widgets: _objectSpread(_objectSpread({}, widgets), {}, {
    CheckboxWidget: withBBCode(widgets.CheckboxWidget)
  })
});

/*
 * PropTypes
 */

DescriptionField.propTypes = _objectSpread(_objectSpread({}, DescriptionField.propTypes), {}, {
  description: PropTypes.node
});
TitleField.propTypes = _objectSpread(_objectSpread({}, TitleField.propTypes), {}, {
  title: PropTypes.node
});
fieldProps.rawErrors = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.shape({
  message: PropTypes.node,
  type: PropTypes.oneOf(["notice", "error"])
})]));

/**
 * Base form, used by the V2 app
 */
export var MbForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$widgets, _props$fields;
  // ({ ...props } = props);
  var _useValidation = useValidation(props);
  _objectDestructuringEmpty(_useValidation);
  props = Object.assign({}, _useValidation);
  _useValidation;
  var transformErrors = createErrorTransformer(props.uiSchema);
  var wrapperRef = useRef(null);
  props.ref = useCombinedRef([ref, function (form) {
    return form && onError(form.state.errors);
  }]);
  var _useState = useState(props.status),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];

  // Notify parent about status changes
  useEffect(function () {
    var _props$onStatusChange, _props;
    (_props$onStatusChange = (_props = props).onStatusChange) === null || _props$onStatusChange === void 0 || _props$onStatusChange.call(_props, status);
  }, [status]);

  // Update status on errors
  var onError = function onError(errors) {
    setStatus(function (s) {
      return errors !== null && errors !== void 0 && errors.length ? "invalid" : s === "invalid" ? undefined : s;
    });
  };

  // Handle errors
  var _useState3 = useState(props.showErrors || false),
    _useState4 = _slicedToArray(_useState3, 2),
    showErrors = _useState4[0],
    setShowErrors = _useState4[1];
  props.onError = hook(props.onError, function (errors) {
    return onError(errors), setShowErrors(true);
  });
  props.onChange = hook(props.onChange, function (_ref3) {
    var errors = _ref3.errors;
    return onError(errors);
  });
  if (props.scrollToTopOnError === true) {
    props.onError = hook(props.onError, function () {
      var _wrapperRef$current;
      return (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.scrollIntoView(true);
    });
  }

  // Handle submit via AJAX
  if (props.submitUrl) {
    props.onSubmit = hook(props.onSubmit, /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref4) {
        var formData, d, r, errors, property, _t;
        return _regeneratorRuntime().wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              formData = _ref4.formData;
              setStatus("submitting");
              _context.prev = 1;
              _context.next = 2;
              return mbFetch(props.submitUrl, {
                method: "POST",
                headers: {
                  "Content-Type": props.enctype || "application/json"
                },
                body: formData
              });
            case 2:
              r = _context.sent;
              _context.next = 3;
              return r.json();
            case 3:
              d = _context.sent;
              _context.next = 5;
              break;
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              d = {
                error: "Ein Fehler ist aufgetreten!"
              };
            case 5:
              // Success
              if (d.success || d.redirect) {
                setStatus("valid");
                props.onSuccess && props.onSuccess(d);
                if (d.redirect) {
                  document.location.href = d.redirect;
                }
              }
              // Error
              else if (d.error || d.validationErrors) {
                if (props.onError) {
                  /** @type {import("react-jsonschema-form").AjvError[]} */
                  errors = [];
                  if (d.error) {
                    errors.push({
                      message: d.error
                    });
                  } else if (d.validationErrors) {
                    for (property in d.validationErrors) {
                      errors.push({
                        property: property,
                        message: d.validationErrors[property],
                        async: true
                      });
                    }
                  }
                  if (errors.length) props.onError(transformErrors(errors));
                }
              } else {
                setStatus("submitted");
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 4]]);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
  }
  props.formContext = props.formContext || {};
  props.formContext.showErrors = showErrors;
  if (status) {
    props.className = (props.className || "") + " " + status;
    props.formContext.status = status;
  }
  props = _objectSpread(_objectSpread(_objectSpread({}, overrides), props), {}, {
    widgets: _objectSpread(_objectSpread({}, overrides.widgets), (_props$widgets = props.widgets) !== null && _props$widgets !== void 0 ? _props$widgets : {}),
    fields: _objectSpread(_objectSpread({}, overrides.fields), (_props$fields = props.fields) !== null && _props$fields !== void 0 ? _props$fields : {}),
    transformErrors: transformErrors
  });
  if (React.Children.count(props.children) === 0) {
    var isSubmitting = status === "submitting";
    var buttonStatusProps = {};
    if (isSubmitting) {
      buttonStatusProps["disabled"] = true;
    }
    return /*#__PURE__*/_jsx("div", {
      ref: wrapperRef,
      children: /*#__PURE__*/_jsx(Form, _objectSpread(_objectSpread({}, props), {}, {
        children: /*#__PURE__*/_jsx("div", {
          className: "clearfix",
          children: /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
            className: "btn btn-primary",
            type: "submit"
          }, buttonStatusProps), {}, {
            children: isSubmitting ? "Einen Moment bitte..." : props.submitText || "Abschließen"
          }))
        })
      }))
    });
  } else {
    return /*#__PURE__*/_jsx(Form, _objectSpread({}, props));
  }
});

/**
 * Extended form, used everywhere else.
 */
export var DefaultForm = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var initialFormData = _ref6.formData,
    onChange = _ref6.onChange,
    onError = _ref6.onError,
    children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded);
  var _useState5 = useState(initialFormData),
    _useState6 = _slicedToArray(_useState5, 2),
    formData = _useState6[0],
    setFormData = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    errors = _useState8[0],
    setErrors = _useState8[1];
  var formRef = useCombinedRef([function (form) {
    return form && _objectSpread(_objectSpread({}, form), {}, {
      formData: formData,
      setFormData: setFormData,
      errors: errors,
      setErrors: setErrors
    });
  }, ref], [formData, errors]);
  var handleChange = hook(onChange, function (_ref7) {
    var formData = _ref7.formData;
    return setFormData(formData);
  });
  var handleError = hook(onError, setErrors);
  var error = errors && errors.find(function (e) {
    return e.async || !e.property && e.message;
  });
  return /*#__PURE__*/_jsx(MbForm, _objectSpread(_objectSpread({
    ref: formRef,
    enctype: "application/x-www-form-urlencoded",
    formData: formData,
    liveValidate: true,
    onChange: handleChange,
    onError: handleError
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [error && /*#__PURE__*/_jsx("p", {
        className: "error-detail text-danger",
        children: /*#__PURE__*/_jsx(HtmlToReact, {
          html: error.message
        })
      }), children]
    })
  }));
});
export default DefaultForm;

/*
 * Utils
 */

/**
 * Combine multiple refs into one, and update on dependency changes.
 * @param {(((val: any) => any) | React.MutableRefObject<any>)[]} refs
 * @param {any[]?} deps
 */
function useCombinedRef(refs) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ref = useRef(null);
  var updater = function updater(instance) {
    ref.current = instance;
    var _iterator = _createForOfIteratorHelper(refs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref9;
        var _ref8 = _step.value;
        if (typeof _ref8 === "function") instance = (_ref9 = _ref8(instance)) !== null && _ref9 !== void 0 ? _ref9 : instance;else if (typeof _ref8 === "object" && _ref8) _ref8.current = instance;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
  var effectRef = useRef(false);
  useEffect(function () {
    if (!effectRef.current) effectRef.current = true;else updater(ref.current);
  }, deps);
  return updater;
}
;

/**
 * @typedef {{ setFormData: (formData: any) => void, formData: any, setErrors: (errors: any) => void, errors: any }} FormRef
 */
//# sourceMappingURL=index.js.map